import { InjectionToken, StaticProvider } from '@angular/core';
import { BdAppConfigResponse } from '@bindoc-projects/app-config-domain-lib';

export const USER_COOKIE_CCM19_DOMAIN_ID = new InjectionToken<string>(
  'Cookie Manager CCM19 DomainId',
);

export const USER_COOKIE_CCM19_API_KEY = new InjectionToken<string>(
  'Cookie Manager CCM19 ApiKey',
);

export const CCM19_SCRIPT_BASE_URL = 'https://cloud.ccm19.de/app.js';

export const CCM19_EMBEDDINGS_YOUTUBE_NAME = 'YouTube Video';
export const CCM19_EMBEDDINGS_LINKEDIN_NAME = 'LinkedIn';
export const CCM19_EMBEDDINGS_TRACKING_NAME = 'Dash0 Web Monitoring';
export const CCM19_EMBEDDINGS_ZENDESK_NAME = 'Zendesk';

export function provideUserCookieDomainId(
  appConfigResponse: BdAppConfigResponse,
): StaticProvider {
  if (appConfigResponse.variables['COOKIE_MANAGER_DOMAIN_ID']) {
    return {
      provide: USER_COOKIE_CCM19_DOMAIN_ID,
      useValue: appConfigResponse.variables['COOKIE_MANAGER_DOMAIN_ID'],
    };
  } else {
    console.error("No 'COOKIE_MANAGER_DOMAIN_ID' found in app config response");
    return {
      provide: USER_COOKIE_CCM19_DOMAIN_ID,
      useValue: '',
    };
  }
}
